import { takeLatest, put, call, select } from 'redux-saga/effects';
import { getSearchResults } from 'yoda-interfaces/lib/Search/SearchApi';
import productSearchActionTypes from '../actionTypes/ProductSearchActionTypes';

export const context = (state) => state.context;

function* productSearchSaga(action) {
    try {
        const contextData = yield select(context);
        const productSearchResults = yield call(
            getSearchResults,
            action.params,
            action.regionZone,
            action.version,
            contextData.featureFlags.disableNewAutoSuggestion
        );
        yield put({
            type: productSearchActionTypes.PRODUCTSEARCH_GET_SUCCESS,
            productSearchResults,
        });
    } catch (error) {
        yield put({ type: productSearchActionTypes.PRODUCTSEARCH_GET_ERROR, error });
    }
}

const watchProductSearchRequest = function* watchProductSearchRequest() {
    yield takeLatest(productSearchActionTypes.PRODUCTSEARCH_GET_REQUEST, productSearchSaga);
};

watchProductSearchRequest.sagaName = 'productSearchSaga';

export default watchProductSearchRequest;
